<template>
  <div class="gxcj">
    <div class="gxcj-title">
      <div>高校财经数据库</div>
      <p>优质资讯 优胜之道</p>
    </div>
    <div class="gxcj-content">
      <p class="content-title">
        高校财经数据库作为国内首家专业中文财经数据库，推出专为中国高等教育系统定制的信息数据库网站。20年之信息积累，回溯期长、数据延续性强，1400多家平面与网络媒体构成强大数据源，197个行业覆盖、海量数据、分类检索、友善的使用界面，500余家高校、公共图书馆与科研机构正式用户，连续20多年的使用体验与认可。
      </p>
      <div class="content-wrap">
        <div class="content-item">
          <div class="item-til">
            <div></div>
            中国经济新闻库
          </div>
          <p class="item-en">(China Economic News)</p>
          <p class="item-ind">
            4,905,900篇文献,该数据库收录了中国范围内及相关的海外商业经济信息，以媒体报导为主，数据来源于中国千余种报章与期刊及部分合作伙伴提供的专业信息，内容按198个行业及中国各省市地区分类。
          </p>
        </div>
        <div class="content-item">
          <div class="item-til">
            <div></div>
            中国商业报告库
          </div>
          <p class="item-en">(China Business Report)</p>
          <p class="item-ind">
            443,890篇文献，该数据库收录了经济学家及学者关于中国宏观经济、中国金融、中国市场及中国各个行业的评论文章和研究文献，以及政府的各项年度报告全文。
          </p>
        </div>
        <div class="content-item">
          <div class="item-til">
            <div></div>
            中国法律法规库
          </div>
          <p class="item-en">(China Laws & Regulations)</p>
          <p class="item-ind">
            350,010篇文献，该数据库收录以中国法律法规文献为主，兼收其他国家法律法规文献。收录自1949年以来中华人民共和国中央和地方的法律法规，以及各行业有关条例和案例。其中部分数据可追溯至1903年。
          </p>
        </div>
        <div class="content-item">
          <div class="item-til">
            <div></div>
            中国统计数据库
          </div>
          <p class="item-en">(China Statistics)</p>
          <p class="item-ind">
            638,908篇文献，该数据库大部分数据收录自1995年以来国家及各省市地方统计局的统计年鉴及海关统计、经济统计快报、中国人民银行统计季报等月度及季度统计资料，其中部分数据可追溯至1949年，亦包括部分海外地区的统计数据。
          </p>
        </div>
        <div class="content-item">
          <div class="item-til">
            <div></div>
            中国上市公司文献库
          </div>
          <p class="item-en">(China Listed Company)</p>
          <p class="item-ind">
            410,927篇文献，该数据库收录了沪、深交易所上市公司 (包括A股,
            B股及H股)的资料，网罗深圳和上海证券市场的上市公司各类招股书、上市公告、中期报告、年终报告、重要决议等文献资料。
          </p>
        </div>
        <div class="content-item">
          <div class="item-til">
            <div></div>
            INFOBANK环球商讯库
          </div>
          <p class="item-en">(INFOBANK Business Briefing)</p>
          <p class="item-ind">
            10,432篇文献，该数据库收录了香港主板及创业板1000多家上市公司1999年以来公开披露的各类公告及业绩简述。可按公司代码、行业分类、公告类型进行分类检索，为用户提供了一个全面了解香港上市公司动态的有效途径。
          </p>
        </div>
        <div class="content-item">
          <div class="item-til">
            <div></div>
            中国医疗健康库
          </div>
          <p class="item-en">(China Medical & Health)</p>
          <p class="item-ind">
            27,264篇文献，该数据库收录了中国一百多种专业和普及性医药报刊的资料，向用户提供中国医疗科研、新医药、专业医院、知名医生、病理健康资讯。
          </p>
        </div>
        <div class="content-item">
          <div class="item-til">
            <div></div>
            ENGLISH PUBLICATIONS
          </div>
          <p class="item-ind">193,426篇文献，该数据库收录了部分英文报刊的全文数据及新华社英文实时新闻资料。</p>
        </div>
        <div class="content-item">
          <div class="item-til">
            <div></div>
            中国企业产品库
          </div>
          <p class="item-en">(China Company Directory)</p>
          <p class="item-ind">
            279,322篇文献，该数据库收录了中国27万家制造业、邮电业及运输等公司的综合资料，如负责人、联系方法及企业规模等。文献分为十三个大类。
          </p>
        </div>
        <div class="content-item">
          <div class="item-til">
            <div></div>
            中国中央及地方政府机构库
          </div>
          <p class="item-en">(Chinese Government Agency)</p>
          <p class="item-ind">
            168个机构，该数据库保存了中央国务院机构及地方政府各部门资料，内容包括各机构的负责人、机构职能、地址、电话等主要资料。
          </p>
        </div>
        <div class="content-item">
          <div class="item-til">
            <div></div>
            名词解释库 (Glossary)
          </div>
          <p class="item-en">(Glossary)</p>
          <p class="item-ind">
            1,550个名词，该数据库主要提供有关中国大陆所使用的经济、金融、科技等行业的名词解释，以帮助海外用户更好地了解文献中上述行业名词的准确定义。
          </p>
        </div>
        <div class="content-item">
          <div class="item-til">
            <div></div>
            中国人物库
          </div>
          <p class="item-en">(China Who's Who)</p>
          <p class="item-ind">
            17,552个人物，该数据库提供详尽的中国主要政治人物、工业家、银行家、企业家、科学家以及其他著名人物的简历及有关的资料，此库文献内容主要根据对中国800多种公开发行资料的搜集而生成。
          </p>
        </div>
        <div class="content-item">
          <div class="item-til">
            <div></div>
            中国拟建在建项目数据库
          </div>
          <p class="item-en">(Proposed and On-going Engineering Projects in China)</p>
          <p class="item-ind">
            7,980篇文献，集中央国务院部委机构及地方政府各部门资料，包括各机构的负责人、机构职能、地址、电话等主要资料。
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {}
  },
  methods: {},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import '../../styles/global.less';
.gxcj-title {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 536px;
  background: url(~@/assets/image/back_gxcj.png) center no-repeat;
  background-size: 100% 100%;
  div {
    margin: 48px 0;
    font-size: 48px;
    font-weight: 600;
    color: #ffffff;
  }
  p {
    font-size: 24px;
    font-weight: 400;
    color: #ffffff;
    line-height: 28px;
  }
}
.gxcj-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 80%;
  margin: 64px auto;
  .content-title {
    margin: 0 0 64px;
    font-size: 20px;
    font-weight: 400;
    color: #333333;
    line-height: 40px;
  }
  .content-wrap {
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-wrap: wrap;
    margin: 64px auto;

    .content-item {
      width: 40%;
      padding: 24px;
      margin: 24px 0;
      min-height: 160px;
      background: #ffffff;
      border-radius: 10px;
      box-shadow: 0px 0px 16px 0px #cfd8eb;
      .item-til {
        position: relative;
        font-size: 24px;
        font-weight: 600;
        color: #333333;

        div {
          position: absolute;
          bottom: -5px;
          left: 0;
          width: 50px;
          height: 20px;
          opacity: 0.3;
          background: #0377ff;
          border-radius: 10px;
        }
      }
      .item-en {
        margin: 10px 0;
        font-size: 18px;
        font-weight: 600;
        color: #333333;
      }
      .item-ind {
        margin: 24px 0;
        font-size: 16px;
        font-weight: 400;
        color: #656565;
        line-height: 22px;
      }
    }
  }
}
</style>
